import { Namespace } from '../abc/lazy/Namespace';
import { Multiname } from '../abc/lazy/Multiname';
export function makeMultiname(v, namespace) {
    var rn = new Multiname(null, 0, 17 /* RTQNameL */, [], null);
    rn.set(v, namespace || Namespace.PUBLIC);
    return rn;
}
